exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main[data-v-078753dd]{height:calc(100% - 40px);width:100%;position:relative;overflow:auto;background-color:#f3f6fb;-webkit-box-shadow:12px 4px 10px #cdcdcd;box-shadow:12px 4px 10px #cdcdcd}.content_wrap[data-v-078753dd]{background:#ffffff;-webkit-box-shadow:0px 0px 10px 0px rgba(0,0,0,0.05);box-shadow:0px 0px 10px 0px rgba(0,0,0,0.05);border-radius:10px;margin:15px}.content_wrap .page_title[data-v-078753dd]{padding:0 15px;height:50px;font-weight:normal;line-height:50px;font-size:18px;border-bottom:1px solid #eeeeee;color:#2993ff}.content_wrap.no-shadow[data-v-078753dd]{-webkit-box-shadow:none;box-shadow:none}\n", ""]);

// exports
